/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type DocumentTypeItem = typeof DocumentTypeItem[keyof typeof DocumentTypeItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentTypeItem = {
  RULE: 'RULE',
  PRORULE: 'PRORULE',
  NOTICE: 'NOTICE',
  PRESDOCU: 'PRESDOCU',
} as const;
